import {
  updateIsShowDrawingManager,
  updatePolygonFences
} from '../../../../../common/redux/reducer/commonSlices/polygonSlice';
import {
  updateCenter as updateMapCenter,
  updateZoom
} from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import {
  updateFence,
  updateIsShow
} from '../../../../../common/redux/reducer/commonSlices/circleSlice';
import {
  addGeofenceMapping,
  getGeofencesAction
} from '../../../redux/reducer/yaantracSlices/geofenceSlice';
import { useEffect, useState } from 'react';

export const useGeofenceAssign = ({
  dispatch,
  setIsCircular,
  setFilteredRow,
  setCardOpen,
  setIsOpen
}: any) => {
  const onAssign = async (params: any) => {
    let { radius, latAndLongDetails } = params;

    dispatch(updateIsShowDrawingManager(false));
    dispatch(updateMapCenter(latAndLongDetails));
    dispatch(
      updateFence([
        {
          id: params?.geoZoneId,
          center: params?.latAndLongDetails?.[0],
          radius: params?.radius * 1000
        }
      ])
    );
    dispatch(updateIsShow(true));
    dispatch(updatePolygonFences([]));

    if (params?.geoType === 'polygon') {
      setIsCircular(false);
      dispatch(
        updatePolygonFences([{ id: params?.geoZoneId, paths: latAndLongDetails }])
      );
      dispatch(updateZoom(latAndLongDetails));
    } else {
      let newRadius = radius + radius / 2;
      let scale = newRadius / 500;
      let zoom = 5 - Math.log(scale) / Math.log(2);
      dispatch(updateZoom(zoom));
      setIsCircular(true);
    }

    setFilteredRow(params);

    setCardOpen(false);
    setIsOpen('Assign Geofence');
  };

  return { onAssign };
};

export const useAddGeofenceAssign = ({
  deviceList,
  filteredRow,
  setIsOpen,
  dispatch,
  abortController,
  setSearchValue,
  formReset,
  onClose,
  isOpen,
  assignVehicleValue,
  getValues,
  setMapClick
}: any) => {
  const [mappedVehicles, setMappedVehicles] = useState([]);

  const mappedDeviceList = [
    {
      id: 'selectAll',
      label: 'Select All',
      checked: false
    },
    ...deviceList?.map((vehicle: any) => ({
      id: vehicle,
      label: vehicle.toUpperCase(),
      checked: false
    }))
  ];

  const assignGeofence = async (data: any) => {
    let payload = {
      geoZoneId: filteredRow?.geoZoneId,
      vehicle:
        data?.vehicle && data?.vehicle?.map((item: any) => item.id).includes('selectAll')
          ? deviceList?.join(',')
          : !data?.vehicle
          ? []
          : data?.vehicle
              ?.map((item: any) => {
                return item?.id;
              })
              .join(','),
      assignVehicle: setIsOpen
    };
    await dispatch(addGeofenceMapping(payload));
    if (abortController.current) abortController.current.abort();
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    setSearchValue('searchFilter' as any, '');
    formReset();
    onClose();
    setIsOpen('');
    await dispatch(getGeofencesAction({ signal: signal }));
  };

  useEffect(() => {
    if (isOpen === 'Assign Geofence') {
      assignVehicleValue('geofence', filteredRow?.geofenceName);
      const filterVehicle = filteredRow?.vehicleNumber?.map(
        (value: any, index: number) => ({
          id: value,
          label: value?.toUpperCase()
        })
      );

      assignVehicleValue('vehicle', filterVehicle);
      setMappedVehicles(filterVehicle);
    }
  }, [isOpen, filteredRow]);

  useEffect(() => {
    setMapClick(getValues('geoType') ?? 'circular');
  }, [getValues('geoType')]);

  return { mappedDeviceList, assignGeofence, mappedVehicles };
};
